import {MI} from "../init";
/**
 * @constructor
 */
export default function GameGroups() {

    /** @type {Object<string,MadnesGroup>} */
    this._groups = {};
}

/**
 * @param {string} name
 * @returns {MadnesGroup}
 */
GameGroups.prototype.create = function(name) {
    return this.add(name);
};

/**
 * @param {string} name
 * @returns {MadnesGroup}
 */
GameGroups.prototype.add = function(name) {
    this._groups[name] = MI.addGroup(name);
    return this._groups[name];
};

/**
 * @param {string} name
 * @returns {MadnesGroup}
 */
GameGroups.prototype.get = function(name) {
    return this._groups[name];
};